<template>
	<div
		class="mx-auto w-full"
		:class="cn('px-5 py-11 md:px-8 md:py-[60px] lg:px-12', props.class)"
	>
		<div class="mx-auto w-full 2xl:max-w-[1440px]" :class="cn('', mainClass)">
			<slot />
		</div>
	</div>
</template>
<script setup lang="ts">
import { cn } from '@/utils';
import type { HTMLAttributes } from 'vue';

const props = defineProps<{
	class?: HTMLAttributes['class'];
	mainClass?: HTMLAttributes['class'];
}>();
</script>
